import {
  FETCH_PRODUCT_GROUPS_SUCCESS,
  FETCH_PRODUCT_GROUPS_FAILED,
  SAVE_PRODUCT_GROUP_SUCCESS,
  SAVE_PRODUCT_GROUP_FAILED,
  DELETE_RECORD_SUCCESS
} from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_GROUPS_SUCCESS:
      return {
        ...state,
        productGroups: action.productGroups,
        errors: null
      };
    case FETCH_PRODUCT_GROUPS_FAILED:
      return {
        ...state,
        productGroups: {},
        errors: action.errors
      };
    case SAVE_PRODUCT_GROUP_SUCCESS:
      return { ...state, error: false, errors: null };
    case SAVE_PRODUCT_GROUP_FAILED:
      return {
        ...state,
        errors: action.errors
      };
    case "@@router/LOCATION_CHANGE":
      return {};
    case DELETE_RECORD_SUCCESS:
      if (action.resource === "productGroups") {
        const { productGroups, ...rest } = state;

        const { [action.recordSlug]: removedValue, ...rest1 } = productGroups;

        const newState = { ...rest, productGroups: { ...rest1 } };

        return newState;
      } else {
        return state;
      }
    default:
      return state;
  }
};
